import React, { useState, useEffect, useRef } from "react";
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import "@vtaits/react-color-picker/dist/index.css";
import "react-datepicker/dist/react-datepicker.css";
import PropTypes from "prop-types";
import {
    Container,
    Button,
    Col,
    Row,
    Label,
    Card,
    CardBody,
    CardTitle
} from "reactstrap";
import Select from "react-select";
import { MultiGrid, AutoSizer } from 'react-virtualized';
import styles from './style.css';
import "react-virtualized/styles.css";
import _ from "lodash";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
    getCompanies as onGetCompanies,
    getListWorksheet as onGetWorksheets,
    getPeriods as onGetPeriods,
    clearListWorksheet as onClearWorksheets,
    exportExcelWorksheet as onExportExcelWorksheets,
    balancingWorksheet as onBalancingWorksheets,
    depreciationWorksheet as onDepreciationWorksheet,
} from "../../store/actions";
import { useSelector, useDispatch } from "react-redux";
import PulseLoader from "react-spinners/PulseLoader";
import CurrencyFormat from 'react-currency-format';
import ModalConfirmationBalancing from './modalConfirmationBalancing'
import ModalConfirmationDepreciation from "./modalConfirmationUpdateDepreciation";

const Worksheet = () => {
    //meta title
    document.title = "Worksheet | Des Counts";
    const dispatch = useDispatch();
    const [isOpenBalancing, SetIsOpenBalancing] = useState(false)
    const [isOpenDepreciation, SetIsOpenDepreciation] = useState(false)
    const [listColumn, setListColumn] = useState([])
    const [listData, setListData] = useState([])

    const [selectedCompany, setSelectedCompany] = useState(null);
    const [optionCompany, setOptionCompany] = useState([]);
    function handleSelectCompany(e) {
        setSelectedCompany(e);
    }

    const [selectedPeriod, setSelectedPeriod] = useState(null);
    const [optionPeriod, setOptionPeriod] = useState([]);
    function handleSelectPeriod(e) {
        setSelectedPeriod(e);
    }

    const [selectedSort, setSelectedSort] = useState({ label: "Code", value: 1 },);
    const [optionSort, setOptionSort] = useState([
        { label: "Code", value: 1 },
        { label: "List of Account", value: 2 }
    ]);
    function handleSelectSort(e) {
        setSelectedSort(e);
    }

    const [selectedSortType, setSelectedSortType] = useState({ label: "A - Z", value: "asc" });
    const [optionSortType, setOptionSortType] = useState([
        { label: "A - Z", value: "asc" },
        { label: "Z - A", value: "desc" },
    ]);
    function handleSelectSortType(e) {
        setSelectedSortType(e);
    }

    const filterCompany = useRef("");
    const filterPeriod = useRef("");

    const {
        companies,
        loadingCompany,
        periods,
        loadingPeriod,
        worksheets,
        loading,
        summaryAccounts,
        summarys,
        accountNumbers,
    } = useSelector(state => ({
        companies: state.Company.companies,
        loadingCompany: state.Company.loading,
        periods: state.Period.periods,
        loadingPeriod: state.Period.loading,
        worksheets: state.Worksheet.listWorksheet,
        loading: state.Worksheet.loading,
        summaryAccounts: state.Worksheet.listSummaryAccount,
        summarys: state.Worksheet.listSummary,
        accountNumbers: state.Worksheet.listAccountNumber,
    }));


    const onRefreshCommand = () => {
        if (selectedCompany && selectedPeriod) {
            dispatch(onGetWorksheets({
                companyId: selectedCompany ? selectedCompany.value : null,
                periodId: selectedPeriod ? selectedPeriod.value : null,
            }));
        }
    }

    const onResetFilterCommand = () => {
        filterCompany.current.clearValue();
        filterPeriod.current.clearValue();
    }

    const onExportExcel = () => {
        dispatch(onExportExcelWorksheets({
            companyId: selectedCompany ? selectedCompany.value : null,
            periodId: selectedPeriod ? selectedPeriod.value : null,
        }))
    }

    const onOpenBalancingCommand = () => {
        if (selectedCompany && selectedPeriod) {
            SetIsOpenBalancing(true)
        }
    }

    const onCloseBalancingCommand = () => {
        SetIsOpenBalancing(false)
    }

    const onBalancingWorksheetCommand = () => {
        SetIsOpenBalancing(false)
        if (selectedCompany && selectedPeriod) {
            dispatch(onBalancingWorksheets({ companyId: selectedCompany.value, periodId: selectedPeriod.value }))
        }
    }

    const onOpenDepreciationCommand = () => {
        if (selectedCompany && selectedPeriod) {
            SetIsOpenDepreciation(true)
        }
    }

    const onCloseDepreciationCommand = () => {
        SetIsOpenDepreciation(false)
    }

    const onDepreciationWorksheetCommand = () => {
        SetIsOpenDepreciation(false)
        if (selectedCompany && selectedPeriod) {
            dispatch(onDepreciationWorksheet({ companyId: selectedCompany.value, periodId: selectedPeriod.value }))
        }
    }

    useEffect(() => {
        dispatch(onGetCompanies({}));
    }, [dispatch]);

    useEffect(() => {
        if (companies) {
            setOptionCompany(companies.map((item) => {
                return { label: item.name, value: item.id }
            }))
        }
    }, [companies])

    useEffect(() => {
        if (periods) {
            setOptionPeriod(periods.map((item) => {
                return { label: item.name, value: item.id }
            }))
        }
    }, [periods])

    useEffect(() => {
        if (selectedCompany) {
            filterPeriod.current.clearValue()
            dispatch(onGetPeriods({ companyId: selectedCompany.value }))
        }
        setSelectedPeriod(null)
        setOptionPeriod([])
    }, [selectedCompany])

    useEffect(() => {
        dispatch(onClearWorksheets())
    }, [selectedCompany, selectedPeriod])

    useEffect(() => {
        if (worksheets) {
            const newDataColumns = [
                { dataKey: 'accountCode' },
                { dataKey: 'accountName' },
                { dataKey: 'beginningBalanceDebit' },
                { dataKey: 'beginningBalanceCredit' },
            ];
            const newListData = worksheets.map((item, idxData) => {
                const Detail = () => {
                    var res = {};
                    var newDataColumnsTemp = newDataColumns;
                    item.detail.map((i) => {
                        var temp = {};
                        temp['accNum' + 'Debit' + i.accountNumberId] = i.debit == 0 ? '-' : <CurrencyFormat value={i.debit} displayType={'text'} thousandSeparator='.' decimalSeparator=',' decimalScale={0} />
                        temp['accNum' + 'Credit' + i.accountNumberId] = i.credit == 0 ? '-' : <CurrencyFormat value={i.credit} displayType={'text'} thousandSeparator='.' decimalSeparator=',' decimalScale={0} />
                        res = { ...res, ...temp }
                        newDataColumnsTemp = [...newDataColumnsTemp, { dataKey: 'accNum' + 'Debit'  + i.accountNumberId}, { dataKey: 'accNum' + 'Credit'  + i.accountNumberId}]
                    })
                    if (idxData == 0) {
                        setListColumn([...newDataColumnsTemp,
                        { dataKey: 'contentAccountCompoundDebit' },
                        { dataKey: 'contentAccountCompoundCredit' },
                        { dataKey: 'contentAccountTrialBalanceDebit' },
                        { dataKey: 'contentAccountTrialBalanceCredit' },
                        { dataKey: 'adjustmentDebit' },
                        { dataKey: 'adjustmentCredit' },
                        { dataKey: 'nsspDebit' },
                        { dataKey: 'nsspCredit' },
                        { dataKey: 'profitLossDebit' },
                        { dataKey: 'profitLossCredit' },
                        { dataKey: 'balanceSheetDebit' },
                        { dataKey: 'balanceSheetCredit' },
                        ]);
                    }
                    return res
                }
                const Compound = () => {
                    var res = {};
                    var temp = {};
                    temp['contentAccountCompoundDebit'] = item.compoundJurnal.debit == 0 ? '-' : <CurrencyFormat value={item.compoundJurnal.debit} displayType={'text'} thousandSeparator='.' decimalSeparator=',' decimalScale={0} />
                    temp['contentAccountCompoundCredit'] = item.compoundJurnal.credit == 0 ? '-' : <CurrencyFormat value={item.compoundJurnal.credit} displayType={'text'} thousandSeparator='.' decimalSeparator=',' decimalScale={0} />
                    res = { ...res, ...temp }
                    return res
                }
                const TrialBalance = () => {
                    var res = {};
                    var temp = {};
                    temp['contentAccountTrialBalanceDebit'] = item.trialBalance.debit == 0 ? '-' : <CurrencyFormat value={item.trialBalance.debit} displayType={'text'} thousandSeparator='.' decimalSeparator=',' decimalScale={0} />
                    temp['contentAccountTrialBalanceCredit'] = item.trialBalance.credit == 0 ? '-' : <CurrencyFormat value={item.trialBalance.credit} displayType={'text'} thousandSeparator='.' decimalSeparator=',' decimalScale={0} />
                    res = { ...res, ...temp }
                    return res
                }
                const Adjustment = () => {
                    var res = {};
                    var temp = {};
                    temp['adjustmentDebit'] = item.adjustment.debit == 0 ? '-' : <CurrencyFormat value={item.adjustment.debit} displayType={'text'} thousandSeparator='.' decimalSeparator=',' decimalScale={0} />
                    temp['adjustmentCredit'] = item.adjustment.credit == 0 ? '-' : <CurrencyFormat value={item.adjustment.credit} displayType={'text'} thousandSeparator='.' decimalSeparator=',' decimalScale={0} />
                    res = { ...res, ...temp }
                    return res
                }
                const Nssp = () => {
                    var res = {};
                    var temp = {};
                    temp['nsspDebit'] = item.nssp.debit == 0 ? '-' : <CurrencyFormat value={item.nssp.debit} displayType={'text'} thousandSeparator='.' decimalSeparator=',' decimalScale={0} />
                    temp['nsspCredit'] = item.nssp.credit == 0 ? '-' : <CurrencyFormat value={item.nssp.credit} displayType={'text'} thousandSeparator='.' decimalSeparator=',' decimalScale={0} />
                    res = { ...res, ...temp }
                    return res
                }
                const ProfitLoss = () => {
                    var res = {};
                    var temp = {};
                    temp['profitLossDebit'] = item.profitLoss.debit == 0 ? '-' : <CurrencyFormat value={item.profitLoss.debit} displayType={'text'} thousandSeparator='.' decimalSeparator=',' decimalScale={0} />
                    temp['profitLossCredit'] = item.profitLoss.credit == 0 ? '-' : <CurrencyFormat value={item.profitLoss.credit} displayType={'text'} thousandSeparator='.' decimalSeparator=',' decimalScale={0} />
                    res = { ...res, ...temp }
                    return res
                }
                const BalanceSheet = () => {
                    var res = {};
                    var temp = {};
                    temp['balanceSheetDebit'] = item.balanceSheet.debit == 0 ? '-' : <CurrencyFormat value={item.balanceSheet.debit} displayType={'text'} thousandSeparator='.' decimalSeparator=',' decimalScale={0} />
                    temp['balanceSheetCredit'] = item.balanceSheet.credit == 0 ? '-' : <CurrencyFormat value={item.balanceSheet.credit} displayType={'text'} thousandSeparator='.' decimalSeparator=',' decimalScale={0} />
                    res = { ...res, ...temp }
                    return res
                }
                var detail = Detail()
                var compound = Compound()
                var trialBalance = TrialBalance()
                var adjustment = Adjustment()
                var nssp = Nssp()
                var profitLoss = ProfitLoss()
                var balanceSheet = BalanceSheet()
                return {
                    accountCode: item.accountCode,
                    accountName: item.accountName,
                    beginningBalanceDebit: item.accountDebit == 0 ? '-' : <CurrencyFormat value={item.accountDebit} displayType={'text'} thousandSeparator='.' decimalSeparator=',' decimalScale={0} />,
                    beginningBalanceCredit: item.accountCredit == 0 ? '-' : <CurrencyFormat value={item.accountCredit} displayType={'text'} thousandSeparator='.' decimalSeparator=',' decimalScale={0} />,
                    ...detail,
                    ...compound,
                    ...trialBalance,
                    ...adjustment,
                    ...nssp,
                    ...profitLoss,
                    ...balanceSheet
                }
            })
            setListData(newListData)
        }
    }, [worksheets])

    useEffect(() => {
        if(listColumn && listColumn.length > 0){
            const newListData = listData;
            var titleRowTop = {};
            var titleRow = {};
            var sumRow = {};
            var sumRowTemp = {};
            var sumRowFinal = {};
            listColumn.map((data, i) => {
                sumRowTemp[data.dataKey] = ""
                sumRowFinal[data.dataKey] = ""
                if(data.dataKey == "accountCode"){
                    titleRow[data.dataKey] = "Code"
                    titleRowTop[data.dataKey] = ""
                    sumRow[data.dataKey] = "TOTAL"
                }
                else if(data.dataKey == "accountName"){
                    titleRow[data.dataKey] = "List of Account"
                    titleRowTop[data.dataKey] = ""
                    sumRow[data.dataKey] = ""
                }
                else if(data.dataKey == "beginningBalanceDebit"){
                    titleRow[data.dataKey] = "Debit"
                    titleRowTop[data.dataKey] = "Beginning Balance"
                    sumRow[data.dataKey] = worksheets.reduce((acc, cur) => acc + cur.accountDebit, 0) == 0 ? '-' : <CurrencyFormat value={worksheets.reduce((acc, cur) => acc + cur.accountDebit, 0)} displayType={'text'} thousandSeparator='.' decimalSeparator=',' decimalScale={0} />
                }
                else if(data.dataKey == "beginningBalanceCredit"){
                    titleRow[data.dataKey] = "Credit"
                    titleRowTop[data.dataKey] = ""
                    sumRow[data.dataKey] = worksheets.reduce((acc, cur) => acc + cur.accountCredit, 0) == 0 ? '-' : <CurrencyFormat value={worksheets.reduce((acc, cur) => acc + cur.accountCredit, 0)} displayType={'text'} thousandSeparator='.' decimalSeparator=',' decimalScale={0} />
                }
                else{
                    var selisih = 0
                    var nomDebit = 0
                    var nomCredit = 0

                    if(summarys && summarys.length > 0){
                        selisih = summarys[4].credit - summarys[4].debit
                        nomDebit = summarys[5].debit
                        nomCredit = summarys[5].credit
                    }
                    var absSelisih = Math.abs(selisih)
                    if(selisih < 0){
                        nomDebit = nomDebit + absSelisih
                    }
                    else {
                        nomDebit = nomDebit - absSelisih
                    }
                    if(nomDebit < 0){
                        nomCredit = Math.abs(nomDebit)                         
                        nomDebit = 0                         
                    }

                    if(data.dataKey.toLowerCase().includes("debit")){
                        titleRow[data.dataKey] = "Debit"
                        if(data.dataKey.toLowerCase().includes("accnum")){
                            var tempId = parseInt(data.dataKey.substring(11))
                            var tempFind = summaryAccounts.filter(s => s.accountNumberId == tempId)
                            if(tempFind.length > 0){
                                titleRowTop[data.dataKey] = tempFind[0].accountName
                                sumRow[data.dataKey] = tempFind[0].debit == 0 ? '-' : <CurrencyFormat value={tempFind[0].debit} displayType={'text'} thousandSeparator='.' decimalSeparator=',' />
                            }
                        }
                        if(summarys && summarys.length > 0){
                            if(data.dataKey == "contentAccountCompoundDebit"){
                                titleRowTop[data.dataKey] = "COMPOUND-JOURNAL ENTRY"
                                sumRow[data.dataKey] = summarys[0].debit == 0 ? '-' : <CurrencyFormat value={summarys[0].debit} displayType={'text'} thousandSeparator='.' decimalSeparator=',' />
                            }
                            if(data.dataKey == "contentAccountTrialBalanceDebit"){
                                titleRowTop[data.dataKey] = "TRIAL BALANCE"
                                sumRow[data.dataKey] = summarys[1].debit == 0 ? '-' : <CurrencyFormat value={summarys[1].debit} displayType={'text'} thousandSeparator='.' decimalSeparator=',' />
                            }
                            if(data.dataKey == "adjustmentDebit"){
                                titleRowTop[data.dataKey] = "ADJUSTMENT"
                                sumRow[data.dataKey] = summarys[2].debit == 0 ? '-' : <CurrencyFormat value={summarys[2].debit} displayType={'text'} thousandSeparator='.' decimalSeparator=',' />
                            }
                            if(data.dataKey == "nsspDebit"){
                                titleRowTop[data.dataKey] = "NSSP"
                                sumRow[data.dataKey] = summarys[3].debit == 0 ? '-' : <CurrencyFormat value={summarys[3].debit} displayType={'text'} thousandSeparator='.' decimalSeparator=',' />
                            }
                            if(data.dataKey == "profitLossDebit"){
                                titleRowTop[data.dataKey] = "Profit & Loss"
                                sumRow[data.dataKey] = summarys[4].debit == 0 ? '-' : <CurrencyFormat value={summarys[4].debit} displayType={'text'} thousandSeparator='.' decimalSeparator=',' />
                            }
                            if(data.dataKey == "balanceSheetDebit"){
                                titleRowTop[data.dataKey] = "Balance Sheet"
                                sumRow[data.dataKey] = summarys[5].debit == 0 ? '-' : <CurrencyFormat value={summarys[5].debit} displayType={'text'} thousandSeparator='.' decimalSeparator=',' />
                                sumRowFinal[data.dataKey] = nomDebit == 0 ? '-' : <CurrencyFormat value={nomDebit} displayType={'text'} thousandSeparator='.' decimalSeparator=',' />
                            }
                        }
                    }
                    else{
                        titleRow[data.dataKey] = "Credit"
                        titleRowTop[data.dataKey] = ""

                        if(data.dataKey.toLowerCase().includes("accnumcredit")){
                            var tempId = parseInt(data.dataKey.substring(12))
                            var tempFind = summaryAccounts.filter(s => s.accountNumberId == tempId)
                            if(tempFind.length > 0){
                                sumRow[data.dataKey] = tempFind[0].credit == 0 ? "-" : <CurrencyFormat value={tempFind[0].credit} displayType={'text'} thousandSeparator='.' decimalSeparator=',' />
                            }
                        }

                        if(summarys && summarys.length > 0){
                            if(data.dataKey == "contentAccountCompoundCredit"){
                                titleRowTop[data.dataKey] = "COMPOUND-JOURNAL ENTRY"
                                sumRow[data.dataKey] = summarys[0].credit == 0 ? '-' : <CurrencyFormat value={summarys[0].credit} displayType={'text'} thousandSeparator='.' decimalSeparator=',' />
                            }
                            if(data.dataKey == "contentAccountTrialBalanceCredit"){
                                titleRowTop[data.dataKey] = "TRIAL BALANCE"
                                sumRow[data.dataKey] = summarys[1].credit == 0 ? '-' : <CurrencyFormat value={summarys[1].credit} displayType={'text'} thousandSeparator='.' decimalSeparator=',' />
                            }
                            if(data.dataKey == "adjustmentCredit"){
                                titleRowTop[data.dataKey] = "ADJUSTMENT"
                                sumRow[data.dataKey] = summarys[2].credit == 0 ? '-' : <CurrencyFormat value={summarys[2].credit} displayType={'text'} thousandSeparator='.' decimalSeparator=',' />
                            }
                            if(data.dataKey == "nsspCredit"){
                                titleRowTop[data.dataKey] = "NSSP"
                                sumRow[data.dataKey] = summarys[3].credit == 0 ? '-' : <CurrencyFormat value={summarys[3].credit} displayType={'text'} thousandSeparator='.' decimalSeparator=',' />
                            }
                            if(data.dataKey == "profitLossCredit"){
                                titleRowTop[data.dataKey] = "Profit & Loss"
                                sumRow[data.dataKey] = summarys[4].credit == 0 ? '-' : <CurrencyFormat value={summarys[4].credit} displayType={'text'} thousandSeparator='.' decimalSeparator=',' />
                                var nom = summarys[4].credit - summarys[4].debit
                                sumRowTemp[data.dataKey] = nom == 0 ? '-' : <CurrencyFormat value={nom} displayType={'text'} thousandSeparator='.' decimalSeparator=',' />
                            }
                            if(data.dataKey == "balanceSheetCredit"){
                                titleRowTop[data.dataKey] = "Balance Sheet"
                                sumRow[data.dataKey] = summarys[5].credit == 0 ? '-' : <CurrencyFormat value={summarys[5].credit} displayType={'text'} thousandSeparator='.' decimalSeparator=',' />
                                sumRowFinal[data.dataKey] = nomCredit == 0 ? '-' : <CurrencyFormat value={nomCredit} displayType={'text'} thousandSeparator='.' decimalSeparator=',' />
                            }
                        }
                    }
                }
            })

            newListData.unshift(sumRow)
            newListData.unshift(sumRowTemp)
            newListData.unshift(sumRowFinal)
            newListData.unshift(titleRow)
            newListData.unshift(titleRowTop)
            setListData(newListData)
        }
    }, [listColumn])

    useEffect(() => {
        const newListData = listData.slice(5)
        //code
        if(selectedSort.value == 1){
            if(selectedSortType.value == "asc"){
                setListData([...listData.slice(0, 5), ...newListData.sort(function(a, b) {
                    return a.accountCode.toLowerCase().localeCompare(b.accountCode.toLowerCase());
                 })])
            }
            if(selectedSortType.value == "desc"){
                setListData([...listData.slice(0, 5), ...newListData.sort(function(a, b) {
                    return a.accountCode.toLowerCase().localeCompare(b.accountCode.toLowerCase());
                 }).reverse()])
            }
        }
        // list of account
        if(selectedSort.value == 2){
            if(selectedSortType.value == "asc"){
                setListData([...listData.slice(0, 5), ...newListData.sort(function(a, b) {
                    return a.accountName.toLowerCase().localeCompare(b.accountName.toLowerCase());
                 })])
            }
            if(selectedSortType.value == "desc"){
                setListData([...listData.slice(0, 5), ...newListData.sort(function(a, b) {
                    return a.accountName.toLowerCase().localeCompare(b.accountName.toLowerCase());
                 }).reverse()])
            }
        }
    }, [selectedSort, selectedSortType])

    const cellRender = function({columnIndex, key, rowIndex, style}) {
        var rowData = listData[rowIndex]
        var widthVal = style.width;
        widthVal = rowIndex == 0 ? 300 : widthVal;
        widthVal = columnIndex == 1 ? 300 : widthVal;
        var textAlign = rowIndex == 1 ? "center" : "right";
        textAlign = columnIndex == 0 ? "center" : textAlign;
        textAlign = columnIndex == 1 ? "left" : textAlign;
        textAlign = rowIndex == 0 ? "center" : textAlign;

        if(listColumn.length == 0 || listData.length == 0 || worksheets.length == 0){
            return null
        }

        var newStyle = {
            height : style.height,
            left : style.left, 
            position : style.position,
            top : style.top,
            width : widthVal,
            padding: 5,
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textAlign: textAlign,
        }

        if(rowIndex > 0){
            newStyle = { ...newStyle, borderBottom: "1px solid" }
        }

        if(rowIndex >= 2 && rowIndex <= 4){
            newStyle = { ...newStyle, fontWeight: "bold" }
        }

        if(rowIndex == 0 && columnIndex > 1){
            if(listColumn[columnIndex].dataKey.toLowerCase().includes("credit")){
                newStyle.width = 150
                return (
                    <div className={'bg-light'} key={key} style={{...newStyle, zIndex: 10}}
                            title={rowData[listColumn[columnIndex].dataKey]}>
                    </div>
                )
            }
            return (
                <div className={'bg-light'} key={key} style={{...newStyle, zIndex: 11}}
                        title={rowData[listColumn[columnIndex].dataKey]}>
                    {rowData[listColumn[columnIndex].dataKey]}
                </div>
            )
        }

        return (
            <div className={'bg-light'} key={key} style={newStyle}
                    title={rowData[listColumn[columnIndex].dataKey]}>
                {rowData[listColumn[columnIndex].dataKey]}
            </div>
        )
    }

    return (
        <React.Fragment>
            <ModalConfirmationBalancing show={isOpenBalancing} onSubmit={onBalancingWorksheetCommand} onClose={onCloseBalancingCommand} />
            <ModalConfirmationDepreciation show={isOpenDepreciation} onSubmit={onDepreciationWorksheetCommand} onClose={onCloseDepreciationCommand} />
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Worksheet" breadcrumbItem="Worksheet's List" />
                    <Row className="mb-3">
                        <Col xs="12">
                            <Card>
                                <CardBody className="pt-0">
                                    <CardTitle className="my-3">Filter</CardTitle>
                                    <Row>
                                        <Col className="col-12 col-sm-6">
                                            <div>
                                                <Label>Company</Label>
                                                <Select
                                                    value={selectedCompany}
                                                    onChange={handleSelectCompany}
                                                    options={optionCompany}
                                                    isLoading={loadingCompany}
                                                    isClearable={true}
                                                    ref={filterCompany}
                                                    className="select2-selection"
                                                    menuPosition="fixed"
                                                />
                                            </div>
                                        </Col>
                                        <Col className="col-12 col-sm-6">
                                            <div>
                                                <Label>Period</Label>
                                                <Select
                                                    value={selectedPeriod}
                                                    onChange={handleSelectPeriod}
                                                    options={optionPeriod}
                                                    isLoading={loadingPeriod}
                                                    isClearable={true}
                                                    ref={filterPeriod}
                                                    className="select2-selection"
                                                    menuPosition="fixed"
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className="mt-3">
                                        <Col className="justify-content-end">
                                            <Button color="primary" className="btn btn-primary waves-effect waves-light  float-end" style={{ minWidth: '200px' }}
                                                disabled={loading}
                                                onClick={onRefreshCommand}>
                                                <i className="bx bx-filter-alt"></i>
                                            </Button>
                                            <Button color="info" className="btn btn-info waves-effect waves-light me-2 float-end" style={{ minWidth: '100px' }}
                                                disabled={loading}
                                                onClick={onResetFilterCommand}>
                                                Clear
                                            </Button>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="12">
                            <Card>
                                <CardBody>
                                    {
                                        !loading && selectedCompany && selectedPeriod && worksheets &&
                                        <>
                                            <div className="d-flex justify-content-end mb-2">
                                                {
                                                    selectedCompany && selectedPeriod &&
                                                    <div>
                                                        <Button color="primary" className="btn btn-primary waves-effect waves-light"
                                                            onClick={onOpenBalancingCommand}>
                                                            Update Balancing
                                                        </Button>
                                                    </div>
                                                }
                                                {
                                                    selectedCompany && selectedPeriod &&
                                                    <div>
                                                        <Button color="primary" className="btn btn-primary waves-effect waves-light ms-2"
                                                            onClick={onOpenDepreciationCommand}>
                                                            Update Depreciation
                                                        </Button>
                                                    </div>
                                                }
                                                <div className=" flex-grow-1">
                                                    <div className="d-flex ms-3">
                                                        <b className="align-self-center fw-bold">Sort</b>
                                                        <Select
                                                            value={selectedSort}
                                                            onChange={handleSelectSort}
                                                            options={optionSort}
                                                            isClearable={false}
                                                            className="react-select--inline ms-3"
                                                            classNamePrefix="react-select"
                                                        />
                                                        <Select
                                                            value={selectedSortType}
                                                            onChange={handleSelectSortType}
                                                            options={optionSortType}
                                                            isClearable={false}
                                                            className="react-select--inline ms-3"
                                                            classNamePrefix="react-select"
                                                        />
                                                    </div>
                                                </div>
                                                <Button color="success" className="btn btn-success waves-effect waves-light"
                                                    onClick={onExportExcel}>
                                                    Export Excel
                                                </Button>
                                            </div>
                                            <AutoSizer disableHeight>
                                                {({width}) => (
                                                    <MultiGrid
                                                        fixedColumnCount={2}
                                                        fixedRowCount={5}
                                                        cellRenderer={cellRender}
                                                        columnWidth={({ index }) => index == 1 ? 300 : 150}
                                                        columnCount={16 + (summaryAccounts.length * 2)}
                                                        enableFixedColumnScroll
                                                        enableFixedRowScroll
                                                        height={500}
                                                        rowHeight={30}
                                                        rowCount={listData.length}
                                                        width={width}
                                                        hideTopRightGridScrollbar
                                                        hideBottomLeftGridScrollbar
                                                        classNameBottomRightGrid={styles.RightGrid}
                                                    />
                                                )}
                                            </AutoSizer>
                                            
                                            {/* <div className="table-responsive">
                                                <div className="d-flex bg-light">
                                                    <div className='text-center bg-light align-self-center py-2' style={{ minWidth: '100px', marginLeft: '10px', marginRight: '10px', position:"sticky" }}>
                                                        Code
                                                    </div>
                                                    <div className='text-start bg-light  align-self-center py-2 ms-0' style={{ minWidth: '200px', marginLeft: '10px', marginRight: '10px', position:"sticky" }}>
                                                        List of Account
                                                    </div>
                                                    <div className='text-center bg-light pt-2' style={{ minWidth: '220px' }}>
                                                        <div>Beginning Balance</div>
                                                        <div className="d-flex">
                                                            <div className='text-center bg-light py-2  ms-0' style={{ minWidth: '100px', marginLeft: '0px', marginRight: '10px' }}>
                                                                Debit
                                                            </div>
                                                            <div className='text-center bg-light py-2  ms-0' style={{ minWidth: '100px', marginLeft: '0px', marginRight: '10px' }}>
                                                                Credit
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {
                                                        worksheets && worksheets.length > 0 &&
                                                        worksheets[0].detail.map((item) => {
                                                            return <div key={'headerAccountNumber' + item.accountNumberId} className='text-center bg-light pt-2' style={{ minWidth: '220px' }}>
                                                                <div>{item.accountNumberName}</div>
                                                                <div className="d-flex">
                                                                    <div className='text-center bg-light py-2  ms-0' style={{ minWidth: '100px', marginLeft: '0px', marginRight: '10px' }}>
                                                                        Debit
                                                                    </div>
                                                                    <div className='text-center bg-light py-2  ms-0' style={{ minWidth: '100px', marginLeft: '0px', marginRight: '10px' }}>
                                                                        Credit
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        })
                                                    }
                                                    <div className='text-center bg-light pt-2' style={{ minWidth: '220px' }}>
                                                        <div>COMPOUND-JOURNAL ENTRY</div>
                                                        <div className="d-flex">
                                                            <div className='text-center bg-light py-2  ms-0' style={{ minWidth: '100px', marginLeft: '10px', marginRight: '10px' }}>
                                                                Debit
                                                            </div>
                                                            <div className='text-center bg-light py-2  ms-0' style={{ minWidth: '100px', marginLeft: '10px', marginRight: '10px' }}>
                                                                Credit
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='text-center bg-light pt-2' style={{ minWidth: '220px' }}>
                                                        <div>TRIAL BALANCE</div>
                                                        <div className="d-flex">
                                                            <div className='text-center bg-light py-2  ms-0' style={{ minWidth: '100px', marginLeft: '10px', marginRight: '10px' }}>
                                                                Debit
                                                            </div>
                                                            <div className='text-center bg-light py-2  ms-0' style={{ minWidth: '100px', marginLeft: '10px', marginRight: '10px' }}>
                                                                Credit
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='text-center bg-light pt-2' style={{ minWidth: '220px' }}>
                                                        <div>ADJUSTMENT</div>
                                                        <div className="d-flex">
                                                            <div className='text-center bg-light py-2  ms-0' style={{ minWidth: '100px', marginLeft: '0px', marginRight: '10px' }}>
                                                                Debit
                                                            </div>
                                                            <div className='text-center bg-light py-2  ms-0' style={{ minWidth: '100px', marginLeft: '0px', marginRight: '10px' }}>
                                                                Credit
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='text-center bg-light pt-2' style={{ minWidth: '220px' }}>
                                                        <div>NSSP</div>
                                                        <div className="d-flex">
                                                            <div className='text-center bg-light py-2  ms-0' style={{ minWidth: '100px', marginLeft: '0px', marginRight: '10px' }}>
                                                                Debit
                                                            </div>
                                                            <div className='text-center bg-light py-2  ms-0' style={{ minWidth: '100px', marginLeft: '0px', marginRight: '10px' }}>
                                                                Credit
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='text-center bg-light pt-2' style={{ minWidth: '220px' }}>
                                                        <div>Profit & Loss</div>
                                                        <div className="d-flex">
                                                            <div className='text-center bg-light py-2  ms-0' style={{ minWidth: '100px', marginLeft: '0px', marginRight: '10px' }}>
                                                                Debit
                                                            </div>
                                                            <div className='text-center bg-light py-2  ms-0' style={{ minWidth: '100px', marginLeft: '0px', marginRight: '10px' }}>
                                                                Credit
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='text-center bg-light pt-2' style={{ minWidth: '220px' }}>
                                                        <div>Balance Sheet</div>
                                                        <div className="d-flex">
                                                            <div className='text-center bg-light py-2  ms-0' style={{ minWidth: '100px', marginLeft: '0px', marginRight: '10px' }}>
                                                                Debit
                                                            </div>
                                                            <div className='text-center bg-light py-2  ms-0' style={{ minWidth: '100px', marginLeft: '0px', marginRight: '10px' }}>
                                                                Credit
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                                <Table
                                                    width={1910 + (summaryAccounts ? summaryAccounts.length * 220 : 0)}
                                                    disableHeader={true}
                                                    height={500}
                                                    headerHeight={0}
                                                    rowHeight={30}
                                                    rowCount={listData.length}
                                                    rowGetter={({ index }) => listData[index]}>
                                                    {
                                                        listColumn && listColumn.map((item, idx) => {
                                                            return <Column key={'col' + idx}
                                                                dataKey={item.dataKey}
                                                                cellDataGetter={({ rowData }) => rowData.index}
                                                                disableSort={true}
                                                                flexGrow={1}
                                                                className={
                                                                    (item.dataKey == 'accountCode' ? 'text-center' : (
                                                                        item.dataKey == 'accountName' ? 'text-start' : 'text-end'
                                                                    ))    
                                                                }
                                                                cellRenderer={({
                                                                    dataKey,
                                                                    rowData,
                                                                }) => {
                                                                    return rowData[dataKey];
                                                                }}
                                                                width={idx == 1 ? 200 : 100}
                                                                minWidth={idx == 1 ? 200 : 100}
                                                                maxWidth={idx == 1 ? 200 : 100} />
                                                        })
                                                    }
                                                </Table>

                                                
                                                <div className="d-flex bg-light">
                                                    <div className='text-center bg-light align-self-center py-2' style={{ minWidth: '100px', marginLeft: '10px', marginRight: '10px' }}>
                                                    </div>
                                                    <div className='text-start bg-light  align-self-center py-2 ms-0' style={{ minWidth: '200px', marginLeft: '10px', marginRight: '10px' }}>
                                                    </div>
                                                    <div className='text-center bg-light pt-2' style={{ minWidth: '220px' }}>
                                                        <div className="d-flex">
                                                            <div className='text-end bg-light py-2  ms-0' style={{ minWidth: '100px', marginLeft: '10px', marginRight: '10px' }}>
                                                                {worksheets.reduce((acc, cur) => acc + cur.accountDebit, 0) == 0 ? '-' : <CurrencyFormat value={worksheets.reduce((acc, cur) => acc + cur.accountDebit, 0)} displayType={'text'} thousandSeparator='.' decimalSeparator=',' decimalScale={0} />}
                                                            </div>
                                                            <div className='text-end bg-light py-2  ms-0' style={{ minWidth: '100px', marginLeft: '10px', marginRight: '10px' }}>
                                                                {worksheets.reduce((acc, cur) => acc + cur.accountCredit, 0) == 0 ? '-' : <CurrencyFormat value={worksheets.reduce((acc, cur) => acc + cur.accountCredit, 0)} displayType={'text'} thousandSeparator='.' decimalSeparator=',' decimalScale={0} />}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {
                                                        summaryAccounts &&
                                                        summaryAccounts.map((item) => {
                                                            return <div key={'footerAN' + item.accountNumberId} className='text-center bg-light pt-2' style={{ minWidth: '220px' }}>
                                                                <div className="d-flex">
                                                                    <div className='text-end bg-light py-2  ms-0' style={{ minWidth: '100px', marginLeft: '10px', marginRight: '10px' }}>
                                                                        {item.debit == 0 ? '-' : <CurrencyFormat value={item.debit} displayType={'text'} thousandSeparator='.' decimalSeparator=',' />}
                                                                    </div>
                                                                    <div className='text-end bg-light py-2  ms-0' style={{ minWidth: '100px', marginLeft: '10px', marginRight: '10px' }}>
                                                                        {item.credit == 0 ? '-' : <CurrencyFormat value={item.credit} displayType={'text'} thousandSeparator='.' decimalSeparator=',' />}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        })
                                                    }
                                                    {
                                                        summarys &&
                                                        summarys.map((item, idx) => {
                                                            return <>
                                                                <div className='text-center bg-light pt-2' style={{ minWidth: '220px' }}>
                                                                    <div className="d-flex">
                                                                        <div className='text-end bg-light py-2  ms-0' style={{ minWidth: '100px', marginLeft: '10px', marginRight: '10px' }}>
                                                                            {item.debit == 0 ? '-' : <CurrencyFormat value={item.debit} displayType={'text'} thousandSeparator='.' decimalSeparator=',' />}
                                                                        </div>
                                                                        <div className='text-end bg-light py-2  ms-0' style={{ minWidth: '100px', marginLeft: '10px', marginRight: '10px' }}>
                                                                            {item.credit == 0 ? '-' : <CurrencyFormat value={item.credit} displayType={'text'} thousandSeparator='.' decimalSeparator=',' />}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        })
                                                    }
                                                </div>
                                            </div> */}
                                        </>
                                    }
                                    {
                                        !loading && (!selectedCompany || !selectedPeriod) &&
                                        <div className="d-flex justify-content-center my-5">
                                            <p>Please select company and period.</p>
                                        </div>
                                    }
                                    {
                                        loading &&
                                        <div className="d-flex justify-content-center my-5">
                                            <PulseLoader loading={loading} color={'#FFF'} size={12} className="align-self-center" />
                                        </div>
                                    }
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

Worksheet.propTypes = {
    className: PropTypes.string,
    preGlobalFilteredRows: PropTypes.any,
};

export default Worksheet
